<template>
  <div class="listing-form responsible-company-information margin-auto">
    <Card class="responsible-company-information-wrapper">
      <div slot="title" class="d-flex-center">
        <Avatar icon="md-apps"/>
        <div><p style="color:#000;font-weight:bold">Responsible Company</p></div>
      </div>
      <div>
        <Form ref="ResponsibleCompanyForm" :model="value" label-position="top">
          <FormItem prop="gdr_compliance">
            <span slot="label">
              GDPR compliance
              <Tooltip max-width="300" placement="top" content="example: Yes. Show link that you're GDPR compliant. More info:https://gdpr.eu/checklist/">[?]</Tooltip>
            </span>
            <TinyEditor v-model="value.gdr_compliance"/>
          </FormItem>
          <FormItem prop="web_hosting_location">
            <span slot="label">
              Web hosting location
              <Tooltip max-width="300" placement="top" content="example: France. Proof: https://kromnix.com/legal-notice/">[?]</Tooltip>
            </span>
            <TinyEditor v-model="value.web_hosting_location"/>
          </FormItem>
          <FormItem prop="security_certification">
            <span slot="label">
              Security certification
              <Tooltip max-width="300" placement="top" content="example: ISO 27001, SecNumCloud, TLS, SSL, IPFSor DigiCert. Proof: Links to show your official certificates.">[?]</Tooltip>
            </span>
            <TinyEditor v-model="value.security_certification"/>
          </FormItem>
          <FormItem prop="green_initiative">
            <span slot="label">
              Green initiatives
              <Tooltip max-width="300" placement="top" content="example: Member of any Environmental Management System associations supporting CO2 reduction, reforestation, ocean conservancy, plastic reduction. Proof: Links to show your green initiatives.">[?]</Tooltip>
            </span>
            <TinyEditor v-model="value.green_initiative"/>
          </FormItem>
          <FormItem prop="green_label">
            <span slot="label">
              Green labels
              <Tooltip max-width="300" placement="top" content="example: ISO 14001, ISO 14064. Proof: Links to show your official labels.">[?]</Tooltip>
            </span>
            <TinyEditor v-model="value.green_label"/>
          </FormItem>
          <FormItem prop="csr_certification">
            <span slot="label">
              CSR certifications
              <Tooltip max-width="300" placement="top" content="example: ISO 26000, ESG, DPEF, Ecovadis, Engagé RSE Label, or UN Global Compact member. Proof: Links to show your CSR certifications.">[?]</Tooltip>
            </span>
            <TinyEditor v-model="value.csr_certification"/>
          </FormItem>
        </Form>
      </div>
    </Card>
  </div>
</template>

<script>
import TinyEditor from '@/components/ui/TinyEditor'

export default {
  props: {
    value: {
      type: Object,
      required: true
    }
  },

  components: {
    TinyEditor
  },

  methods: {
    handleSubmit () {
      this.$refs.ResponsibleCompanyForm.validate((valid) => {
        if (valid) {
          this.$Message.success('Success!')
        } else {
          this.$Message.error('Fail!')
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.responsible-company-information {
  max-width:700px;
  .responsible-company-information-wrapper {
    .ivu-card-head {
      .ivu-avatar {
        background-color:#b00101;
        margin-right:10px
      }
    }
  }
}
</style>
<style lang="scss">
.responsible-company-information {
  form {
    label.ivu-form-item-label {
      font-weight: bold;
      color: #000;
    }
  }
}
</style>
